import { memo } from "react";
import "Components/PlaybackLayout/PlaybackLayout.less";
import VideoContainer from "Components/PlaybackLayout/VideoContainer";
import TimelineHeader from "Components/PlaybackLayout/TimelineHeader";
import HistoricalTimelineToolbar from "Components/PlaybackLayout/HistoricalTimelineToolbar";
import HistoricalTimeline from "Components/PlaybackLayout/HistoricalTimeline";

function PlaybackLayout() {
	return (
		<div className="playback-layout">
			<VideoContainer />
			<div className="playback-main">
				<TimelineHeader />
				<HistoricalTimeline />
				<div className="horizontal" />
				<HistoricalTimelineToolbar />
			</div>
		</div>
	);
}

export default memo(PlaybackLayout);
